import { Directive, HostListener, Inject } from "@angular/core";
import { SessionHandlerService, SessionHandlerServiceToken } from "@feature_core/session/session.module";

@Directive({
  selector: "[sessionReviveClick]"
})
export class SessionReviveClickDirective {

  @HostListener("click") onClick() {
    this.doRevive();
  }

  constructor(
      @Inject(SessionHandlerServiceToken)
        protected _sessionHandler: SessionHandlerService,
  ) {
  }

  private doRevive() {
    this._sessionHandler.reviveSession();
  }
}
